import { jsx as s } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import e from "./styles.module.less.js";
const p = m((o, t) => {
  const {
    value: a,
    ...r
    // this must be last and is the div props
  } = o;
  return /* @__PURE__ */ s("div", { ref: t, ...r, className: `${e.progressBar} ${r.className}`, children: /* @__PURE__ */ s("div", { className: e.cover, style: { width: `${100 - a}%` } }) });
});
export {
  p as ProgressBar
};
